module.exports = __webpack_public_path__ + "media/assets/images/blog/nosco_remote_interface-f8b24a5f33cdf6ded95c3d307dde819e.jpg";